export const cyan50 = "#e6f5f8";
export const cyan100 = "#ccf1f6";
export const cyan200 = "#99e4ee";
export const cyan300 = "#66d6e5";
export const cyan400 = "#33c9dd";
export const cyan500 = "#01bcd5";
export const cyan600 = "#00a2cc";
export const cyan700 = "#0089c4";
export const cyan800 = "#0070bb";
export const cyan900 = "#0056b2";
export const cyan1000 = "#003f94";
export const cyanA100 = "#01f1f6";
export const cyanA200 = "#01ddea";
export const cyanA400 = "#009ac0";
export const cyanA500 = "#00659e";
export const cyanA1000 = "#194d4d";
